
import { CompetitionsHub } from '../../components/competitions/CompetitionsHub/CompetitionsHub';

export default function CompetitionsScreen() {
  return <CompetitionsHub />;
}
